import {Spin } from 'antd'

function Loader() {
  return (
    <div className="flex justify-center items-center">
      <Spin />
    </div>
  );
}

export default Loader;
